<template>
  <div id="about" class="text">
    <h1>About</h1>
    "Reinvent the wheel. They probably did it wrong anyway."
    <h2>Philosophy</h2>
    My motto for almost everything I do is: Try it yourself first, then look for help
    if you struggle. As opposed to the usual mentallity of not reinventing the
    wheel, I prefer to do just that. Although this can seem like a waste of time
    in some respects, I believe that:
    <ol>
      <li>
      Most of the time, you will spend more time looking for and adapting the
      solutions you find to your problem anyway, so why not just implement it
      yourself.
      </li>
      <li>
      Even if there is already a better solution out there, you gain nothing
      personally from using it. By doing it yourself, you gain the experience and
      knowledge of both how to solve the problem, and also what the intricate
      details are to the solution. This improves your understanding of the
      problem, and your skills as a developer in general.
      </li>
    </ol>
    Most times I find that doing things the above way sets me apart from the
    rest, as I can better understand the tasks that I work on.
    <h2>Workflow & Environment</h2>
    My setup consists of a minimalistic, highly optimised environment,
    including:
    <ul>
      <li><strong>Vim:</strong> as my base editor with some plugins (mainly for
      linting) and numerous additional vim scripts that enhance workflow</li>
      <li><strong>Tmux:</strong> a terminal multiplexer that provides multiple
      workspaces in one terminal. This allows for a more complex work
      environment than just one terminal with vim</li>
      <li><strong>Bash scripting:</strong> an array of bash scripts that enhance
      my productivity by automating setup, traversal and management of projects.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>



// WEBPACK FOOTER //
// src/components/about.vue